<script>
import { mapActions } from "vuex";

export default {
  data: function () {
    return {
      series: [],
      chartOptions: {
        chart: {
          height: 500,
          type: "radialBar",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          radialBar: {
            track: {
              background: "#a7d1b5",
            },
            startAngle: 0,
            endAngle: 270,
            hollow: {
              margin: 15,
              size: "10%",
              position: "front",
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                show: false,
              }
            },
            barLabels: {
              enabled: true,
              formatter: function(seriesName, opts) {
                return seriesName;
              },
              offsetX: -8,
              fontWeight: '500',
              fontSize: '12px',
            },
            maxValue: 5
          },
        },
        title: {
          text: this.language === 'tr' ? 'Yeşil Mutabakat Hizalama (SKA Hizalama Anket Sonucu)' : "Green Deal Alignment (SDG Alignment Survey Result)",
          align: "center",
          style: {
            fontSize: "20px",
            heigth: "100px",
            fontFamily: "Muli', Arial, sans-serif",
          },
          /* offsetX: -100 */
        },
        colors: [
          "#366345",
          "#2E6B42",
          "#267340",
          "#1F7A3D",
          "#17823B",
          "#0F8A38",
          "#089136",
          "#009933",
        ],
        labels: [],
        onItemHover: {
          highlightDataSeries: true,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                show: true,
              },
            },
          },
        ],
      },
    };
  },

  created() {
    this.getGreenDeal();
  },
  props: {
    selectedSurveyID: null,
    language: {
      type: String,
      default: localStorage.getItem('lang') || 'en',
    }
  },
  methods: {
    ...mapActions("results", ["greenDeal"]),
    findLargestInteger(arr) {
      let largest = arr[0];
      for (let i = 1; i < arr.length; i++) {
        if (arr[i] > largest) {
          largest = arr[i];
        }
      }
      return largest;
    },
    async getGreenDeal() {
      const width = window.document.getElementsByTagName('body')[0].clientWidth;
      if (width < 1450) {
        this.chartOptions.plotOptions.radialBar.barLabels.fontSize = '11.5px';
      } else if (width >= 1450 && width < 1650) {
        this.chartOptions.plotOptions.radialBar.barLabels.fontSize = '12px';
      } else if (width >= 1650 && width < 1900) {
        this.chartOptions.plotOptions.radialBar.barLabels.fontSize = '13px';
      } else if (width >= 1900 && width < 2500) {
        this.chartOptions.plotOptions.radialBar.barLabels.fontSize = '15px';
      } else {
        this.chartOptions.plotOptions.radialBar.barLabels.fontSize = '18px';
      }

      let counts_list = [];

      let params = {
        company_id: this.$user.company_id,
        is_deleted: false,
        su1_survey_id: this.selectedSurveyID,
        language: this.language,
      };
      this.greenDeal(params)
        .then((response) => {
          response.data.greenDealsSelectionCounts.forEach(item => {
            counts_list.push(item.selectionCount);
          });
          const maxCount = this.findLargestInteger(counts_list);
          response.data.greenDealsSelectionCounts.forEach((item) => {
            this.series.push(item.selectionCount * 100 / maxCount);
            this.chartOptions.labels.push(`${item.greenDealName}: ${item.selectionCount}`);
          });
          counts_list.length = 0;
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },
  },
};
</script>

<template>
  <div class="show-overflow">
    <apex-chart type="radialBar" height="600px" width="100%" :options="chartOptions" :series="series" class="show-overflow"/>
  </div>
</template>

<style lang="scss" scoped>
.apexcharts-text .apexcharts-radialbar-label .apexcharts-no-click {
  font-size: 8px !important;
}
</style>